import React from 'react';
import { motion } from 'framer-motion';
import './PageLoader.scss';

interface PageLoaderProps {
  text?: string;
  minimal?: boolean;
}

const PageLoader: React.FC<PageLoaderProps> = ({
  text = 'Loading...',
  minimal = false
}) => {
  if (minimal) {
    // Minimal loader for step transitions
    return (
      <motion.div
        className="page-loader-minimal"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.2 }}
      >
        <div className="spinner-minimal">
          <motion.div
            className="spinner-ring"
            animate={{ rotate: 360 }}
            transition={{
              duration: 1,
              repeat: Infinity,
              ease: "linear"
            }}
          />
        </div>
        {text && <p className="loader-text-minimal">{text}</p>}
      </motion.div>
    );
  }

  // Full page loader
  return (
    <motion.div
      className="page-loader-full"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.3 }}
    >
      <div className="loader-content">
        {/* Animated logo or spinner */}
        <motion.div
          className="loader-spinner"
          animate={{
            rotate: 360,
          }}
          transition={{
            duration: 1.5,
            repeat: Infinity,
            ease: "linear"
          }}
        >
          <svg width="60" height="60" viewBox="0 0 60 60" fill="none">
            <circle
              cx="30"
              cy="30"
              r="25"
              stroke="#D7A360"
              strokeWidth="4"
              strokeLinecap="round"
              strokeDasharray="80 40"
            />
            <circle
              cx="30"
              cy="30"
              r="18"
              stroke="#3957A0"
              strokeWidth="3"
              strokeLinecap="round"
              strokeDasharray="60 30"
            />
          </svg>
        </motion.div>

        {/* Loading text with animation */}
        <motion.p
          className="loader-text"
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2, duration: 0.5 }}
        >
          {text}
        </motion.p>

        {/* Animated dots */}
        <div className="loader-dots">
          {[0, 1, 2].map((index) => (
            <motion.span
              key={index}
              className="dot"
              animate={{
                opacity: [0.3, 1, 0.3],
                scale: [1, 1.2, 1]
              }}
              transition={{
                duration: 1.2,
                repeat: Infinity,
                delay: index * 0.2,
                ease: "easeInOut"
              }}
            />
          ))}
        </div>
      </div>
    </motion.div>
  );
};

export default PageLoader;
